const styles = {
  card: {
    flex: 1,
  },
  loader: {
    zIndex: (theme) => theme.zIndex.modal + 1,
    color: 'primary.white',
    backdropFilter: 'blur(2px)',
    transition: 'opacity 0.3s ease-in-out',
  },
  listContainer: {
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    gap: 1,
  },
  progressInsideContainer: {
    mx: 2,
    display: 'flex',
    textAlign: 'center',
    flexDirection: 'column',
  },
  progressContent: {
    position: 'relative',
    display: 'inline-flex',
  },
  progressBackground: {
    color: (theme) => theme.palette.grey[300],
  },
  progress: {
    position: 'absolute',
  },
  progressLabelContainer: {
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
    position: 'absolute',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  progressLabel: {
    color: 'text.secondary',
    whiteSpace: 'nowrap',
  },
};

export default styles;
